import { Component, OnDestroy, OnInit, EventEmitter, ViewChild  } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { IResult } from 'app/shared/models/result.model';
import { SnotifyService } from 'ng-snotify';
import { AppConfig } from 'app/app.config';
import { ValidatorService } from 'app/shared/services/validator.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from 'app/shared/services/storage.service';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { RecruitmentService } from '../../recruitment/recruitment.service';
import { CustomerService } from '../../quote/customer.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoPayrollEmployee } from 'app/shared/models/employee/dto-payroll-employee.model';
import { BudgetService } from '../../quote/budget.service';
import { PayrollService } from '../../payroll.service';
import { PositionService } from '../../quote/position.service';
import { CommissionService } from '../../commission.service';
import { IDtoProject } from 'app/shared/models/customer/dto-project.model';
import { IDtoPayroll } from 'app/shared/models/payroll/dto-payroll.model';
import { IDtoPayrollFilter } from 'app/shared/models/payroll/dto-payroll-filter.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalBudgetApproverComponent } from 'app/views/modales/customer/budget-approver/modal-budget-approver.component';
import { map } from 'rxjs/operators';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

@Component({
  selector: 'app-list-payrolls',
  styleUrls: ['./list-payrolls.style.scss'],
  templateUrl: 'list-payrolls.template.html'
})
export class ListPayrollsComponent implements OnDestroy, OnInit {
  private modalRef: BsModalRef;
  private configModal = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private errorMessages: any;
  /**Formularios */
  private formFilter: FormGroup;
  /**Notificaciones */
  private configToast: any;
  /**Variable de trasporte de datos */
  private result: IResult;
  /**Listas */
  private payrolls: IDtoPayroll[];
  private payrollsTem: IDtoPayroll[];
  /**Catalogos */
  @ViewChild('confirmSwal', { static: false }) private confirmSwal: SwalComponent;
  private catalogCustomers: IDtoCatalog[];
  private catalogProjects: IDtoCatalog[];
  private catalogPayrollTypes: IDtoCatalog[];
  private catalogYears: Observable<IDtoCatalog[]>;
  private catalogPeriods: IDtoCatalog[];
  catalogStatus: any;
  /** */
  private statusLabelsMap = {
    'Baja': '<p><span class="label label-plain">Baja</span></p>',
    'Laborando en Red': '<p><span class="label label-success">Laborando en Red</span></p>'
  };
  /**Variables */
  public nav: any;
  private now: number;
  private clients: any;
  /**Slim-control */
  optsSlim: ISlimScrollOptions;
  scrollEvents: EventEmitter<SlimScrollEvent>;

  private profile: string;
  //private customer: string;
  private search: string;
  private projects = new Array() as IDtoProject[];
  private userId: number;
  public constructor(private recruitmentService: RecruitmentService
    , private formBuilder: FormBuilder
    , public snotifyService: SnotifyService
    , private configGeneral: AppConfig
    , private router: Router
    , private route: ActivatedRoute
    , private spinner: NgxSpinnerService
    , private configurationService: ConfigurationService
    , private securityService: SecurityService
    , private storageService: StorageService
    , private identityService: IdentityService
    , private customerService: CustomerService
    , private commissionService: CommissionService
    , private budgetService: BudgetService
    , private payrollService: PayrollService
    , private positionService: PositionService
    , private modalService: BsModalService) {
    this.nav = document.querySelector('nav.navbar');
    this.configToast = configGeneral.getConfigToast();
    this.optsSlim = configGeneral.getConfigSlimScroll();
    this.initializeFormFilter();
    const showRoles = this.securityService.getUserRolesStorage();
    if (showRoles !== '') {
      this.clients = showRoles.listClients;
    }
    this.profile = this.securityService.getProfileStorage('PayrollRecords');
    this.userId = showRoles.employeeId;
  }

  public ngOnInit(): any {
    this.scrollEvents = new EventEmitter<SlimScrollEvent>();
    this.now = Date.now();
    this.nav.className += ' white-bg';
    if (this.configurationService.isReady) {
      this.spinner.show();
      this.obetenerCatalogos();
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.spinner.show();
        this.obetenerCatalogos();
      });
    }
  }
  private initFilters(): void {
    const values = this.storageService.retrieve('payrolls.filters');
    if (values != null) {
      this.formFilter.get('customerId').setValue(values.customerId);
      this.formFilter.get('projectId').setValue(values.projectId);
      if (values.customerId != null) {
        let customer = this.catalogCustomers.filter(c => c.id == values.customerId)[0];
        if (customer != null)
          this.changeCustomer(customer, true);
      }
    }
    // const search = this.storageService.retrieve('recruitments.search');
    // if (search != undefined) {
    //   this.search = search;
    // }
    this.getPayrolls();
  }
  private obetenerCatalogos(): void {
    this.configureCatalogsTrademarks().subscribe(customers => {
      this.catalogCustomers = customers; this.initFilters();
    });
    this.positionService.getCatalogPayrollTypes().subscribe(res => {
      this.catalogPayrollTypes = res;
    });
    this.catalogYears = this.commissionService.getCatalogYears();

    this.catalogStatus = [
      { name: 'Enviada' },
      { name: 'No Enviada' },
    ];
  }
  private configureCatalogsTrademarks(): Observable<IDtoCatalog[]> {
    const clients = new Array as IDtoCatalog[];
    const t = this.customerService.getCatalogCustomersWithCodeNomPayCompany().pipe(
      map((res: any) => {
        this.clients.forEach(element => {
          const z = res.filter(x => x.id == element.clientId)[0];
          if (z != null) {
            clients.push(z);
          }
        });
        return clients;
      })
    );
    return t;
  }
  private changeCustomer(item: IDtoCatalog, init: boolean): void {
    this.getCatalogProjects(item, init);
    this.getCatalogPeriodsByCompanyPayrollType();
    this.getProjects(item);
    //this.customer = item.name;
  }
  private getProjects(dto: IDtoCatalog): void {
    if (dto == null) {
      return;
    }
    this.customerService.getProyectsByCustomer(dto.id)
      .subscribe(
        (x) => {
          this.projects = x.data as IDtoProject[];
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private getCatalogProjects(item: IDtoCatalog, init: boolean): void {
    if (!init) {
      this.formFilter.get('projectId').setValue(null);
    }
    this.catalogProjects = null;
    if (item == null) {
      return;
    }
    this.budgetService.getCatalogProjectCustomersByCustomerIdActivePayroll(item.id).subscribe(res => {
      this.catalogProjects = res;
    });
  }
  private getCatalogPeriodsByCompanyPayrollType(): void {
    this.formFilter.get('periodNom').setValue(null);
    this.catalogPeriods = null;
    let customerId = this.formFilter.value.customerId;
    let payrollTypeId = this.formFilter.value.payrollTypeId;
    let year = this.formFilter.value.year;
    if (customerId == null || payrollTypeId == null|| year == null) {
      return;
    }
    let additional = this.catalogCustomers.filter(x => x.id == customerId)[0].additional;
    let sp = additional.split('|');
    let codeNomCompanyPay = sp[1];
    let staffType = sp[2];
    if (staffType === 'Oficina') {
      let projectId = this.formFilter.value.projectId;
      let project = this.catalogProjects.filter(x => x.id === projectId)[0];
      codeNomCompanyPay = project.name.split('-')[2];
    }
    let codeNomPayrollType = ('00000' + this.formFilter.value.payrollTypeId).slice(-'00000'.length);
    this.spinner.show();
    this.payrollService.getCatalogPeriodsByCompanyPayrollType(codeNomCompanyPay, codeNomPayrollType, year).subscribe(x => {
      this.catalogPeriods = x;
      this.catalogPeriods.forEach(item => {
        item.name = item.name.replace(' Cerrado', ' ');
        item.name = item.name.replace(' Abierto', ' ');
      });
      this.spinner.hide();
    }),
      (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
      };
  }
  private initializeFormFilter() {
    this.formFilter = this.formBuilder.group({
      customerId: [null],
      projectId: [null],
      payrollTypeId: [null],
      periodNom: [null],
      year: [null],
      status: [null],
    });
  }
  private navigateTo(row: IDtoPayrollEmployee, module: string): void {
    const values = this.formFilter.value;
    this.storageService.store('payrolls.filters', values);
    //this.storageService.store('payrolls.search', this.search);
    this.router.navigate(['/payroll/payroll-detail',
      { id: row.id, module: module }], { relativeTo: this.route });
  }
  private getPayrolls(): void {
    this.spinner.show();
    let values = this.formFilter.value as IDtoPayrollFilter;
    values.profile = this.profile;
    this.payrollService.getPayrollsByFilter(values).subscribe((res) => {
      if (res.isCorrect) {
        this.payrolls = res.data as IDtoPayroll[];
        this.payrollsTem = this.payrolls;
        if (this.payrolls.length > 0) {
          this.payrolls.forEach(element => {
            element.periodNom = element.periodNom.replace('Abierto', ' ');

            element.statusFilter = element.statusNameTitle;

            if (element.isLocked == false && element.statusName == 'Cerrada')
            {
              element.statusNameTitle = element.statusName + "/" + element.statusNameTitle + "/Desbloqueada";
            }
            else if (element.isLocked == true && element.statusName == 'Cerrada')
            {
              element.statusNameTitle = element.statusName + "/" +  element.statusNameTitle + "/Bloqueada";
            }
            else if (element.statusName == 'Abierta')
            {
              element.statusNameTitle = element.statusName + "/" +  element.statusNameTitle
            };
            let customer = this.catalogCustomers.filter(x => x.id == element.customerId)[0];
            if (customer != undefined) {
              element.customer = customer.name;
            }
            if (this.catalogProjects != undefined) {
              let project = this.catalogProjects.filter(x => x.id == element.projectId)[0];
              element.project = project.name;
            }
            let payrollType = this.catalogPayrollTypes.filter(x => x.id == element.payrollTypeId)[0];
            element.payrollType = payrollType.name;
          });
        }
      } else {
        this.configGeneral.newToast('Error', res.message, 'error');
      }
      this.spinner.hide();
    });
  }
  public ngOnDestroy(): any {
    this.nav.classList.remove('white-bg');
  }
  private createPayroll(): void {
    this.spinner.show();
    let nullExists = false;
    let values = this.formFilter.value as IDtoPayrollFilter;
    Object.keys(this.formFilter.controls).forEach(val => {
      if (val !== 'status') {
      let v = this.formFilter.get(val).value;
      if (v == null) {
        nullExists = true;
      }
    }
    });
    if (nullExists) {
      this.configGeneral.newToast('Validación', 'Seleccione todos los elementos del filtro para poder crear un registro', 'warning');
      this.spinner.hide();
      return;
    }
    let dto = {} as IDtoPayroll;
    let additionalCustomer = this.catalogCustomers.filter(x => x.id == values.customerId)[0].additional;
    let sp = additionalCustomer.split('|');
    dto.companyPayId = +sp[0];
    dto.codeNomCompanyPay = sp[1];
    let staffType = sp[2];
    if (staffType === 'Oficina') {
      let projectId = this.formFilter.value.projectId;
      let project = this.catalogProjects.filter(x => x.id === projectId)[0];
      let projectSplit = project.name.split('-');
      dto.companyPayId = Number(projectSplit[1]);
      dto.codeNomCompanyPay = projectSplit[2];
    }

    dto.creationDate = this.configGeneral.getLocalISOTime(new Date());
    dto.customerId = values.customerId;
    dto.projectId = values.projectId;
    dto.payrollTypeId = values.payrollTypeId;
    dto.year = values.year;
    dto.periodNom = values.periodNom;
    let additionalPeriod = this.catalogPeriods.filter(x => x.name == values.periodNom)[0].additional;
    let period = additionalPeriod.split('|');
    dto.periodStartNom = new Date(period[0]);
    dto.periodKeyNom = new Date(period[1]);
    dto.status = 1;
    let totalDaysPayroll = this.catalogPayrollTypes.filter(x => x.id == values.payrollTypeId)[0].additional;
    dto.totalDays = Number(totalDaysPayroll);
    dto.employeeid = this.userId;
    this.payrollService.addPayroll(dto)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            //this.updateEmployeePayroll();
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  //   private getProjects(dto: IDtoCatalog): void {
  //     if (dto == null) {
  //         return;
  //     }
  //     this.customerService.getProyectsByCustomer(dto.id)
  //         .subscribe(
  //             (x) => {
  //                 this.projects = x.data as IDtoProject[];
  //             },
  //             (errMessage) => this.errorMessages = errMessage.messages);
  // }
  private addModuleLog(id: number): void {
    let dto = {} as IDtoModuleLog;
    dto.table = 'JobCandidates';
    dto.module = "requestReviews";
    dto.action = 'hiring';
    dto.registryAffectedId = id;
    this.identityService.addModuleLog(dto).subscribe(
      (x) => { });
  }

  private openModalApprovers(dto: IDtoPayroll): void {
    const initialState = {
      title: 'Aprobadores',
      projectCustomerId: dto.projectId,
      customerId: dto.customerId,
      staffTypeName: 'Campo',
      module: 'Payroll'
    };
    this.modalRef = this.modalService.show(ModalBudgetApproverComponent
      , Object.assign({ initialState }
        , this.configGeneral.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
      if (result) {
        this.sendPayrollToCustomer(dto.id, result);
      }
    });
  }

  private sendPayrollToCustomer(payrollId: number, approverUserId: string): void {
    this.spinner.show();
    this.payrollService.sendPayrollToCustomer(payrollId, approverUserId)
      .subscribe(
        (x) => {
          if (x.isCorrect) {
            this.configGeneral.newToast('Éxito', x.message, 'success');
            //this.addModuleLog(this.budget.id, 'update');
          } else {
            this.configGeneral.newToast('Error', x.message, 'error');
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private updatePayrollLocked(row: IDtoPayroll): void {
    let dto = {} as IDtoPayroll;
    dto.id = Number(row.id);
    let text = row.isLocked == true ? 'Desbloqueara' : 'Bloqueara';
    this.confirmSwal.title = 'La prenomina se ' + text + ' ¿Seguro que desea continuar?';
    this.confirmSwal.show().then((result) => {
      if (result.value) {
    if (row.isLocked == true) {
      dto.isLocked = false;
    }
    else {
      dto.isLocked = true;
    };
    this.spinner.show();
    this.payrollService.updatePayrollLocked(dto).subscribe(
      (x) => {
        if (this.configGeneral.notificationSuccessError(x)) {
          this.formFilter.value.lockUser = text;

         let status = row.statusNameTitle.split('/');
             let statusName: string;
              if (status[2] == 'Desbloqueada'){
                statusName = '/Bloqueada';
              }
              else{
                statusName = '/Desbloqueada'
              }
            row.statusNameTitle = status[0] + "/" + status[1] + statusName;
            row.isLocked = !row.isLocked;
            this.payrolls = [...this.payrolls];
        }
        this.spinner.hide();
      },
      (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
      });
      }
    });
  }
  private ApplyStatusFilter(): void {
    this.payrolls = this.payrollsTem;
    this.payrolls  = this.payrolls.filter(registro =>
  registro.statusFilter == this.formFilter.value.status
);
    console.log(this.payrolls);
  }
}
